<template>
    <div>
            <el-card>
                <card-header v-if="isEdit" :title="provider.provider_type_id === 1 ? $t('distributorsUpdate') : $t('suppliersUpdate')" />
                <card-header v-else :title="provider.provider_type_id === 1 ? $t('distributorsCreate') : $t('suppliersCreate')" />
                
                <form>
                    <SelectField v-if="userRole === 'admin'"
                        placeholder="Select.." 
                        :label="$t('providerSelectUser')"
                        :data="users" 
                        :errors="errors.user_id ? errors.user_id[0] : ''" 
                        :value="provider.user_id"
                        v-model="provider.user_id" />

                    <SelectField placeholder="Select.."
                        :disabled="true"
                        :label="$t('providerSelectProvider')"
                        :data="providerTypes"
                        :errors="errors.provider_type_id ? errors.provider_type_id[0] : '' "
                        :value="provider.provider_type_id"
                        v-model="provider.provider_type_id" />
                
                    <InputField 
                        :label="$t('providerLegalName')"
                        :errors="errors.legal_name ? errors.legal_name[0] : ''" 
                        v-model="provider.legal_name" />
                        
                    <InputField :label="$t('providerEmail')" v-model="provider.email" />
                    <InputField :label="$t('providerPhone')" v-model="provider.phone" />
                    <InputField :label="$t('providerFax')" v-model="provider.fax" />
                    <InputField :label="$t('providerWeb')" v-model="provider.web" />
                    <InputField :label="$t('providerCity')" v-model="provider.city" />
                    <InputField :label="$t('providerAddress')" v-model="provider.address" />
                    <InputField :label="$t('providerZip')" v-model="provider.zip" />
                    
                    <lang-tabs 
                        :inputName="$t('providerDisplayName')" 
                        :inputKey="'display_name'"
                        :inputValue="provider.display_name"
                        @langData="updateLangData" 
                        :langErrors="{display_name: errors.display_name ? errors.display_name : errors['display_name.en']}" />
                    <lang-tabs 
                        :inputName="$t('providerDescription')" 
                        :inputKey="'description'"
                        :inputValue="provider.description"
                        @langData="updateLangData" 
                        :langErrors="{description: errors.description ? errors.description : errors['description.en']}" />

                    <UploadFile 
                        :originalImage="provider.logo" 
                        :id="provider.id"
                        :disableUpload="userRole === 'admin' ? false : true"
                        @formData="upload" />
                </form>
            </el-card>
            <shared-buttons v-if="!isEdit" :discardPath="provider.provider_type_id === 1 ? 'Distributors' : 'Suppliers'" @confirm-event-fired="saveNewProvider()"/>
            <shared-buttons v-if="isEdit" :discardPath="provider.provider_type_id === 1 ? 'Distributors' : 'Suppliers'" @confirm-event-fired="save(provider)"/>
    </div>
</template>

<script>
    import api from '@/api/api';
    import {mapGetters} from 'vuex';
    import { success, warning } from '../Notification/notification';
    import UploadFile from '../UploadFile/UploadFile'
    import InputField from '../Inputs/InputField'
    import SelectField from '../Inputs/SelectField'
    import CardHeader from '../LayoutPart/CardHeader'
    import LangTabs from '../LangTabs/LangTabs'
    import model from '@/model/index'

    export default {
        components: {
            UploadFile,
            SelectField,
            InputField,
            CardHeader,
            LangTabs,
        },
        props: {
            provider: {
                required: true
            },
            isEdit: {
                type: Boolean
            }
        },
        data () {
            return {
                errors: {},
                licenceExpire: undefined,
            }
        },
        computed: {
            ...mapGetters({
                currentUser: 'getCurrentUser',
                users: 'getUsers',
                providerTypes: 'getProviderTypes',
                authToken: 'getAuthToken'
            }),
            languages () {
                return model.getLanguages()
            },
            userRole () {
                return localStorage.getItem('user')
            }
        },
        created() {
            if (this.isEdit) {
                this.provider.provider_type_id = this.provider.provider_type.id
            }
            if (this.userRole === 'provider') {
                this.provider.user_id = this.currentUser.id
            }
            this.initProviderTypes();
            this.getUsers();
            
        },
        methods: {
            success,
            warning,
            getUsers() {
                this.$store.dispatch('fetchUsers')
            },
            initProviderTypes() {
                this.$store.dispatch('fetchProviderTypes')
            },
            save(provider) {
                api.updateProvider(provider.id, provider).then(res => {
                    if (res.status === 201 || res.status === 200) {
                        if (this.provider.imageData !== '') {
                            api.uploadProviderImg(provider.id, this.provider.imageData, {
                                headers: {
                                    'Authorization': `Bearer ${this.authToken}`,
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(res => {
                            }).catch(err => {
                            });
                        }
                        
                        provider.logo = this.provider.imageData
                        
                        this.success(res.data.data.provider_type.id === 1 ? 'Distributor' : 'Supplier', 'updated');
                        this.$store.dispatch('updateProviderData', provider);
                        this.$router.go(-1)
                    }
                })
                .catch((err) => {
                    
                    if (err.data.type === 'validation_error') {
                        this.errors = err.data.fields
                    }
                })
            },
            saveNewProvider() {
                api.saveProvider(this.provider).then(res => {
                    if (res.status === 201 || res.status === 200) {
                        const response = res.data.data;
                        
                        if (this.provider.imageData !== '') {
                            api.uploadProviderImg(res.data.data.id, this.provider.imageData, {
                                headers: {
                                    'Authorization': `Bearer ${this.authToken}`,
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                        }

                        this.provider.id = response.id;
                        this.provider.logo = response.logo;

                        if (response.provider_type.id === 1) {
                            setTimeout(() => {
                                this.$store.dispatch('addDistributor', this.provider);
                                this.success('Distributor', 'added');
                            }, 2000)
                        } else {
                            setTimeout(() => {
                                this.$store.dispatch('addSupplier', this.provider);
                                this.success('Supplier', 'added'); 
                            }, 2000)
                        }

                        this.$router.go(-1)
                    }
                }).catch(err => {
                    if (err.data.type === 'validation_error') {
                        this.errors = err.data.fields;
                        this.warning('Please fill out required fields.')
                    }
                });
            },
            upload(image) {
                this.provider.imageData = image;
            },
            updateLangData(updatedData) {
                this.provider[Object.keys(updatedData)[0]] = updatedData[Object.keys(updatedData)[0]]
            }
        }
    }
</script>

<style scoped>
    .el-form-item {
        margin-bottom: 0 !important;
    }
    
    .right {
        float: right;
    }

    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .button {
        margin-left: 10px;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/Providers/CreateProvider.vue